import { ListProvider } from "./list-provider";
import { JobType } from "../../../../business-objects/job-type/job-type.model";
import { JobTypeStoreFacade } from "../../../../business-objects/job-type/job-type.store-facade";

export class JobTypeListProvider extends ListProvider<JobType> {

    getFacade(): JobTypeStoreFacade {
        return this.appFacade.objects.jobType.store;
    }

    getPrimaryField(item: JobType): string {
        return item && item.title;
    }

    getSecondaryField(item: JobType): string {
        return item && item.title;
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/list-picker/form/list-providers/job-type-list-provider.ts